import storage from './storage';

const clearStorage = () => {
  const termlyApiCache = storage.getItem('TERMLY_API_CACHE');
  storage.clear();
  if (termlyApiCache) storage.setItem('TERMLY_API_CACHE', termlyApiCache);
};

export default clearStorage;
